import { View } from 'react-native'
import { useSafeAreaInsets } from 'react-native-safe-area-context'

import { cn } from '@/utils/cn'

function BottomActionPanel({ children, hasTopBorder = true }: { children: React.ReactNode; hasTopBorder?: boolean }) {
  const { bottom } = useSafeAreaInsets()
  return (
    <View
      className={cn(
        'absolute inset-x-0 bottom-0 flex-row items-start gap-2 border-border-10 bg-background-primary p-4',
        hasTopBorder && 'border-t'
      )}
      style={{ height: bottom + 72 }}
    >
      {children}
    </View>
  )
}

export default BottomActionPanel
